/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState } from 'react';
import { Card, Button, Modal } from 'react-bootstrap';
import { MultiColList, IMultiColListProps } from './MultiColList';

export interface ITimelineDetailModal {
  showModal?: boolean;
  modalTitle?: string;
  data?: IMultiColListProps;
  onTriggerModal?(data: any): void;
  onDeny?(): void;
}

export const TimelineDetailModal = (props: ITimelineDetailModal) => {
  const { showModal, modalTitle, data, onDeny, onTriggerModal } = props;
  const [show, setShow] = useState(showModal);

  const handleClose = () => {
    if (onDeny) {
      onDeny();
    }
    setShow(false);
  };

  return (
    <Modal
      centered
      show={show}
      onHide={handleClose}
      scrollable={true}
      size={'lg'}
      fullscreen={'sm-down'}
    >
      <Modal.Header className="border-0">
        <h4>{modalTitle}</h4>
        <Button variant="close" aria-label="Close" onClick={handleClose} />
      </Modal.Header>
      <Modal.Body className="p-0">
        <Card border="light" className="px-0 px-md-4 py-0 border-0">
          <Card.Body>
            <MultiColList {...data} onTriggerModal={onTriggerModal} />
          </Card.Body>
        </Card>
      </Modal.Body>
    </Modal>
  );
};
